export enum LayoutType {
  TABLE = "table",
  CARD = "card",
}
